module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/39YwkeSdZ6qS88Uq2a0sOw-56b8736d5052767dfd8584ffad3d68f8.jpg";